module.exports = __webpack_public_path__ + "img/稻草人.48e154f3.jpg";